import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Tooltip } from "../Tooltip";
import { ThemeProviderContext } from "../ThemeProvider";
import { useContext } from "react";
import { BoldIcon, BulletListIcon, ItalicIcon, LinkIcon } from "../icons";
import { TextSizeDropdown } from "./TextSizeDropdown";
import { TextAlignDropdown } from "./TextAlignDropdown";
export const ALL_FORMAT_OPTIONS = [
    "bold",
    "italic",
    "bulletList",
    "link",
    "textAlign",
    "textSize",
];
export const EditorToolbar = ({ editor, formatOptions = ALL_FORMAT_OPTIONS, isLinkButtonDisabled, handleClickLinkButton, hideEditLinkPopover, isEditorDisabled = false, defaultTextSize, textSizeContainerClassName, }) => {
    const theme = useContext(ThemeProviderContext);
    if (!editor) {
        return null;
    }
    const formatOptionsMap = {
        bold: {
            iconName: "Bold",
            Icon: BoldIcon,
            onClick: () => editor.chain().focus().toggleBold().run(),
            tooltipText: theme.translate("components.rich_text_editor.toolbar.bold"),
            editorKey: "bold",
            isDisabled: isEditorDisabled,
            type: "button",
        },
        italic: {
            iconName: "Italic",
            Icon: ItalicIcon,
            onClick: () => editor.chain().focus().toggleItalic().run(),
            tooltipText: theme.translate("components.rich_text_editor.toolbar.italic"),
            editorKey: "italic",
            isDisabled: isEditorDisabled,
            type: "button",
        },
        bulletList: {
            iconName: "BulletList",
            Icon: BulletListIcon,
            onClick: () => editor.chain().focus().toggleBulletList().run(),
            tooltipText: theme.translate("components.rich_text_editor.toolbar.bullet_list"),
            editorKey: "bulletList",
            isDisabled: isEditorDisabled,
            type: "button",
        },
        link: {
            Icon: LinkIcon,
            iconName: "Link",
            onClick: () => {
                hideEditLinkPopover();
                handleClickLinkButton();
            },
            tooltipText: theme.translate("components.rich_text_editor.toolbar.link"),
            editorKey: "link",
            isDisabled: isLinkButtonDisabled || isEditorDisabled,
            type: "button",
        },
        textAlign: {
            type: "custom",
            tooltipText: theme.translate("components.rich_text_editor.toolbar.text_alignment"),
            Component: TextAlignDropdown,
        },
        textSize: {
            type: "custom",
            tooltipText: theme.translate("components.rich_text_editor.toolbar.text_size"),
            Component: TextSizeDropdown,
        },
    };
    const formatOptionsToDisplay = formatOptions
        .filter((option) => ALL_FORMAT_OPTIONS.includes(option))
        .map((optionName) => formatOptionsMap[optionName]);
    return (_jsx("div", { className: "bg-background-secondary border-b border-b-border-regular rounded-t flex items-center", children: formatOptionsToDisplay.map((formatOption) => {
            return (_jsx(Tooltip, { content: formatOption.tooltipText, trigger: formatOption.type === "button" ? (_jsx("button", { onMouseDown: (event) => event.preventDefault(), onClick: (e) => {
                        e.preventDefault(); // prevent other buttons from being clicked
                        formatOption.onClick();
                    }, "aria-label": formatOption.iconName, className: classNames("!rounded-none pr-1 hover:!bg-general-gray-quaternary p-1", editor.isActive(formatOption.editorKey) &&
                        "!bg-general-gray-tertiary hover:!bg-general-gray-tertiary", formatOption.isDisabled &&
                        "!bg-background-secondary hover:!bg-background-secondary !border-none", formatOption.isDisabled && "text-text-disabled"), disabled: formatOption.isDisabled, children: _jsx(formatOption.Icon, {}) })) : (_jsx("div", { className: "h-[36px] flex", children: _jsx(formatOption.Component, { editor: editor, defaultTextSize: defaultTextSize, textSizeContainerClassName: textSizeContainerClassName }) })), placement: "top", openDelay: 300 }, formatOption.tooltipText));
        }) }));
};
//# sourceMappingURL=EditorToolbar.js.map